import { render, staticRenderFns } from "./RiskExposureHeader.vue?vue&type=template&id=86d99a08"
import script from "./RiskExposureHeader.vue?vue&type=script&lang=js"
export * from "./RiskExposureHeader.vue?vue&type=script&lang=js"
import style0 from "./RiskExposureHeader.vue?vue&type=style&index=0&id=86d99a08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports